import { render, staticRenderFns } from "./UploadDocuments.handler.vue?vue&type=template&id=75a18a7a&"
import script from "./UploadDocuments.handler.vue?vue&type=script&lang=ts&"
export * from "./UploadDocuments.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports